import { useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { PASSWORD_MIN } from '@smile/shared';
import { api } from '../api/client';
import { UserForm, errText } from '../components/UserForm';
import { ROLE_LABEL } from '../lib/format';

/**
 * Můj účet — the legacy `settings` page for oneself: name, e-mail, the
 * company block, and the password change with the current password asked
 * first. The role and the partner terms are the administrator's to change,
 * so they are shown, not edited.
 */
export function Ucet() {
  const q = useQuery({ queryKey: ['account'], queryFn: () => api.account() });
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [again, setAgain] = useState('');
  const pw = useMutation({
    mutationFn: () => api.changePassword({ current, next }),
    onSuccess: () => {
      setCurrent('');
      setNext('');
      setAgain('');
    },
  });
  const ok = current.length > 0 && next.length >= PASSWORD_MIN && next === again;

  return (
    <div className="container">
      <div className="pagehead">
        <h1>Můj účet</h1>
        {q.data && (
          <span className="sub">
            #{q.data.id} · {ROLE_LABEL[q.data.role]}
            {q.data.pricelistTitle ? ` · ceník ${q.data.pricelistTitle}` : ''}
            {q.data.invoicePayment ? ' · Fakturace CK' : ''}
            {q.data.provision ? ` · provize ${q.data.provision} %` : ''}
          </span>
        )}
      </div>
      {q.isPending ? (
        <div className="card state">Načítám…</div>
      ) : q.isError ? (
        <div className="card state" role="alert">
          Účet se nepodařilo načíst.
        </div>
      ) : (
        <>
          <UserForm user={q.data} mode="self" />
          {q.data.promos.length > 0 && (
            <div className="card detailcard" style={{ marginTop: 14 }}>
              <h2>Promo kódy</h2>
              <p className="settings-note">Kódy, kterými web pozná vaše klienty a připíše vám provizi za jejich parkování.</p>
              {q.data.promos.map((p) => (
                <code key={p} className="promo">
                  {p}
                </code>
              ))}
            </div>
          )}
          <form
            className="card detailcard"
            style={{ marginTop: 14 }}
            onSubmit={(e) => {
              e.preventDefault();
              if (ok && !pw.isPending) pw.mutate();
            }}
          >
            <h2>Změna hesla</h2>
            {q.data.legacyPassword && (
              <p className="settings-note">Heslo je uložené starým způsobem (bez soli). Změnou se nic nezhorší; nové heslo platí hned v obou systémech.</p>
            )}
            <div className="efgrid">
              <label className="ef">
                Současné heslo
                <input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
              </label>
              <label className="ef">
                Nové heslo (aspoň {PASSWORD_MIN} znaků)
                <input type="password" autoComplete="new-password" value={next} minLength={PASSWORD_MIN} onChange={(e) => setNext(e.target.value)} required />
              </label>
              <label className="ef">
                Nové heslo znovu
                <input type="password" autoComplete="new-password" value={again} onChange={(e) => setAgain(e.target.value)} required />
              </label>
            </div>
            <div className="efactions">
              <button type="submit" className="btn primary" disabled={!ok || pw.isPending}>
                {pw.isPending ? 'Ukládám…' : 'Změnit heslo'}
              </button>
              {next && again && next !== again && <span className="arrive-error">Hesla se neshodují.</span>}
              {pw.isSuccess && <span className="arrived-mark">✔ Heslo změněno</span>}
              {errText(pw.error) && (
                <span className="arrive-error" role="alert">
                  {errText(pw.error)}
                </span>
              )}
            </div>
          </form>
        </>
      )}
    </div>
  );
}
